import { useQuery } from "react-query";
import { getVehicleRecommendationsByMakeAndModel } from "services/vehicle-recommendations";

export type UseRecommendedVehiclesParams = {
    make: string;
    model?: string;
    variant?: string;
};

const useRecommendedVehicles = (params: UseRecommendedVehiclesParams) => {
    const { data } = useQuery({
        queryKey: ["recommended-vehicles", params.make, params.model, params.variant],
        queryFn: () => getVehicleRecommendationsByMakeAndModel(params),
        retry: 3,
        retryDelay: (attemptIndex, error) => {
            return Math.pow(2, attemptIndex) * 200;
        },
        refetchOnWindowFocus: false,
    });

    return data ?? { total: 0, vehicles: [] };
};

export default useRecommendedVehicles;
